import actionTypes from '../actions/card/actionType';

const initialState = {
  roomCardEnabled: false, // 是否启用房卡
  roomListLoading: false,
  roomList: [],
  enabledVendor: null, // 启用的门锁品牌信息
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_ROOM_LIST_LOADING:
      const { roomListLoading } = payload;
      return {
        ...state,
        roomListLoading,
      };
    case actionTypes.INIT_ROOM_LIST:
      const { roomList } = payload;
      return {
        ...state,
        roomList,
      };
    case actionTypes.SET_ROOM_CARD_ENABLED:
      const { roomCardEnabled } = payload;
      return {
        ...state,
        roomCardEnabled,
      };
    case actionTypes.SET_ENABLED_VENDOR:
      const { enabledVendor } = payload;
      return {
        ...state,
        enabledVendor,
      };
    default:
      return state;
  }
};
